import { IAppState } from '../appState';
import { StateV4 } from './4_migrate_kooperations-nachlass.interface';

export const migrateKooperationsNachlass = (
  previousState: StateV4,
  newVersion: number,
  currentState: IAppState,
): StateV4 => {
  const foundKooperation = currentState.transientState.kooperationen?.some(
    k => k?.code === previousState.vertragsoptionen?.selectedKooperation,
  );

  if (!foundKooperation) {
    delete previousState.vertragsoptionen?.selectedKooperation;
  }
  return {
    ...previousState,
    version: newVersion,
  };
};
